export enum CustomFieldTypes {
  IntegerInput = 'integer-input',
  Blank = 'blank-field',
  GlobalValueSelector = 'global-value-selector',
  GlobalValueDisplay = 'global-value-display',
}
